















import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'product-list-toolbar-sort-select',
  components: ServiceContainer().getComponents()
})

export default class extends Vue {
  @Prop({required: true}) readonly dataSource: string;
  @Prop() readonly catalogData: object;

  readonly sortOptions: object = [{
    name: 'Populaire producten',
    sorting: {sku_s: 'desc'},
  }, {
    name: 'Naam (A-Z)',
    sorting: {name_s: 'asc'},
  }, {
    name: 'Naam (Z-A)',
    sorting: {name_s: 'desc'},
  }, {
    name: 'Laagste prijs',
    sorting: {price: 'asc'},
  }, {
    name: 'Hoogste prijs',
    sorting: {price: 'desc'},
  }];

  private get currentSorting(): object {
    return typeof this.$store.getters[`${this.dataSource}/currentSort`] !== 'undefined' ? this.$store.getters[`${this.dataSource}/currentSort`] : {};
  }

  private get itemCount(): number {
    return this.$store.getters[`${this.dataSource}/totalItemCount`];
  }

  private updatePage(sorting): void {
    this.$store.dispatch(`${this.dataSource}/updatePageSort`, JSON.parse(sorting.target.value));
  }

  private checkSelected(selection): boolean {
    return JSON.stringify(this.currentSorting) === JSON.stringify(selection);
  }
}
